import * as yup from "yup";

export const MyPortfolioFormSchema = yup.object().shape({
  title: yup.string().required("Please enter title."),
  url: yup.string().required("Please enter Past or type a link.").matches(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, "Past or type a link is not valid"),
  description: yup.string().max(60, "Description should be 60 characters"),
});
